// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"q2-z","disabled":"r2-z","seeAllAnswers":"s2-z"};